var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13602_13471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75033 18.3334V14.1667M3.75033 5.83341V1.66675M1.66699 3.75008H5.83366M1.66699 16.2501H5.83366M10.8337 2.50008L9.38851 6.25747C9.1535 6.86849 9.036 7.174 8.85327 7.43099C8.69132 7.65875 8.49232 7.85774 8.26456 8.01969C8.00758 8.20242 7.70207 8.31992 7.09104 8.55493L3.33366 10.0001L7.09105 11.4452C7.70207 11.6802 8.00758 11.7977 8.26456 11.9805C8.49232 12.1424 8.69132 12.3414 8.85327 12.5692C9.036 12.8262 9.1535 13.1317 9.38851 13.7427L10.8337 17.5001L12.2788 13.7427C12.5138 13.1317 12.6313 12.8262 12.8141 12.5692C12.976 12.3414 13.175 12.1424 13.4028 11.9805C13.6597 11.7977 13.9653 11.6802 14.5763 11.4452L18.3337 10.0001L14.5763 8.55493C13.9652 8.31992 13.6597 8.20242 13.4028 8.01969C13.175 7.85774 12.976 7.65875 12.8141 7.43099C12.6313 7.174 12.5138 6.86849 12.2788 6.25747L10.8337 2.50008Z",
    stroke: "#667085",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13602_13471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.01c3464cf6749254f98f1c2f74fc5a6b.svg";
export { ForwardRef as ReactComponent };